import { store } from "../store";
let isLoggedIn = store.getters["isLoggedIn"];

export const redirectAuthenticated = function (to, from, next) {
  if (isLoggedIn) next({ path: "/" });
  else next();
};
